// extracted by mini-css-extract-plugin
export default {"box":"DevelopersPage_box__I7mPC","img":"DevelopersPage_img__7MJ9J"};